import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  OrganizationalStructureState,
  OrganizationalStructureAction,
  OrganizationalStructureReducer,
} from './organizational-structure-reducer';

const initialState: OrganizationalStructureState = {
  governamentalStructures: [],
  loading: false,
};

const OrganizationalStructureStateContext = createContext<OrganizationalStructureState | undefined>(undefined);
const OrganizationalStructureDispatchContext = createContext<React.Dispatch<OrganizationalStructureAction> | undefined>(undefined);

interface OrganizationalStructureProviderProps {
  children: ReactNode;
}

export const OrganizationalStructureProvider: React.FC<OrganizationalStructureProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(OrganizationalStructureReducer, initialState);

  return (
    <OrganizationalStructureStateContext.Provider value={state}>
      <OrganizationalStructureDispatchContext.Provider value={dispatch}>
        {children}
      </OrganizationalStructureDispatchContext.Provider>
    </OrganizationalStructureStateContext.Provider>
  );
};

export const useOrganizationalStructureState = (): OrganizationalStructureState => {
  const context = useContext(OrganizationalStructureStateContext);
  if (context === undefined) {
    throw new Error('useOrganizationalStructureState must be used within a OrganizationalStructureProvider');
  }
  return context;
};

export const useOrganizationalStructureDispatch = (): React.Dispatch<OrganizationalStructureAction> => {
  const context = useContext(OrganizationalStructureDispatchContext);
  if (context === undefined) {
    throw new Error('useOrganizationalStructureDispatch must be used within a OrganizationalStructureProvider');
  }
  return context;
};